import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const AwardItems = [
    {
        subtitle: 'UK',
        title: '7000+ Offers',
        image: 'https://cdn.pixabay.com/photo/2012/04/10/16/14/union-jack-26119__340.png'
    },
    {
        subtitle: 'Canada',
        title: '10000+ Offers',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Flag_of_Canada.svg/1280px-Flag_of_Canada.svg.png'
    },
    {
        subtitle: 'Germany',
        title: '500+ Offers',
        image: 'https://www.transparentpng.com/thumb/germany-flag/CEbjV6-germany-flags-png-picture.png'
    },
    {
        subtitle: 'USA',
        title: '700+ Offers',
        image: 'https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/1024px-Flag_of_the_United_States.svg.png'
    },
    {
        subtitle: 'France',
        title: '800+ Offers',
        image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAFVBMVEX///8BIpXuKToAE5J6gbrzg4ruHTExLxe0AAAA/klEQVR4nO3QSQ0AIAADsHH6l4yKPUhaCc2oWTs9586aOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHixIkTJ06cOHHy4ckD5KrN4eD2boIAAAAASUVORK5CYII='
    },
    {
        subtitle: 'Singapur',
        title: '7500+ Offers',
        image: 'data:image/png;base64,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'
    },
    {
        subtitle: 'China',
        title: '500+ Offers',
        image: 'https://w7.pngwing.com/pngs/221/273/png-transparent-flag-of-china-chinese-communist-revolution-symbol-chinese-flag-border-miscellaneous-floating-thumbnail.png'
    },
    {
        subtitle: 'India',
        title: '100+ Offers',
        image: 'https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1350px-Flag_of_India.svg.png'
    },
    {
        subtitle: 'Itly',
        title: '800+ Offers',
        image: 'https://www.nicepng.com/png/detail/71-715034_download-svg-download-png-italy-flag-small.png'
    },
    {
        subtitle: 'Rusia',
        title: '7500+ Offers',
        image: 'https://cdn.pixabay.com/photo/2013/07/13/14/17/russia-162400__340.png'
    },
    {
        subtitle: 'HongKong',
        title: '500+ Offers',
        image: 'https://flagsweb.com/images/PNG/Flag_of_Hong_Kong.png'
    },
    {
        subtitle: 'Switzerland',
        title: '100+ Offers',
        image: 'https://www.pngall.com/wp-content/uploads/2016/05/Switzerland-Flag-PNG.png'
    }
];

const AboutStudent = () => {
    return (
        <div className="eduvibe-about-two-award edu-winner-area edu-section-gap bg-color-white">
            <div className="container eduvibe-animated-shape">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span className="pre-title">Our Students
</span>
                            <h3 className="title">Across the globe</h3>
                        </div>
                    </div>
                </div>
                <div className="row g-5 mt--20">
                    { AwardItems.map( ( data , i ) => (
                        <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            className="col-lg-2 col-md-5 col-12"
                            animateOnce={ true }
                            key={ i }
                        >
                            <div className="edu-winner-card">
                                <div className="inner">
                                    <div className="icon">
                                        <img src={`${process.env.PUBLIC_URL}${ data.image }`} alt="Award Icon" />
                                    </div>
                                    <div className="content">
                                        <span className="subtitle">{ data.subtitle }</span>
                                        <h6 className="title">{ data.title }</h6>
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>
                    ) ) }
                </div>

                <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-03-07.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-04-01.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-3">
                        <img src="/images/shapes/shape-25-02.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape shape-1">
                        <span className="shape-dot"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutStudent;